import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Category } from '../../../models/Category';
import { User } from '../../../models/User';
import { GlobalService } from '../../../services/global';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.css']
})
export class EditCategoryComponent implements OnInit {
  @HostListener('CategorySelectedEvent', ['$event'])
  onCatSelectEvent(event: any) {
    this.CurrentCategory.ParentID = event.detail;
  }
  CurrentCategory: Category;
  CurUser: User;
  Categories: Category[];

  constructor(private global:GlobalService) { }

  ngOnInit(): void {
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
  }

  SetCategoryParent(cat: number) {
    this.CurrentCategory.ParentID = cat;
  }

  GetCategory(): Category {
    debugger;
    if (this.CurrentCategory.CategoryID <= 0) {
      this.CurrentCategory.CreatedBy = this.CurUser.UserId.toString();
    }
    this.CurrentCategory.UpdatedBy = this.CurUser.UserId.toString();

    if (this.CurrentCategory.ParentID != null) {
      var parent = this.Categories.filter(x => x.CategoryID == this.CurrentCategory.ParentID)[0];
      var maxSortOrder = 0;
      if (parent != null && parent.Children != null) {
        maxSortOrder = parent.Children[parent.Children.length - 1].SortOrder;
        this.CurrentCategory.SortOrder = maxSortOrder + 1;
      }
      else {
        this.CurrentCategory.SortOrder = 0;
      }
      
    }
    return this.CurrentCategory;
  }

}
